import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { applyAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const invite = sessionStorage.getItem("aurora_invite");
    api.post("/auth/google/session", { session_id: sid, invite_code: invite, accept_terms: sessionStorage.getItem("aurora_terms") === "1" })
      .then(({ data }) => {
        sessionStorage.removeItem("aurora_invite");
        sessionStorage.removeItem("aurora_terms");
        applyAuth(data, "back");
        nav("/app", { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e, "Accesso Google non riuscito"));
        nav("/accedi", { replace: true });
      });
  }, [location.hash, nav, applyAuth]);

  return <Loader label="Connessione sicura in corso…" />;
}
